import RightPopupComponent from "components/RightPopup";

import { ReactComponent as PatientRemoveIcon } from 'icons/components/patientRemove.svg';
import { ReactComponent as PatientAddIcon } from 'icons/components/patientAdd.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';

import './index.less';
import './themes/default.less';

import ItemClient from "components/ItemClient";
import ItemHuman from "components/ItemHuman";
import SelectClient from "components/SelectClient";
import InputPhone from "components/InputPhone";
import SelectDate from "components/SelectDate";
import Button from "components/Button";

export default class AddPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.blankInfo = {
            status: "WI_CREATED",
            doctorId: null,
            cabinetId: null,
            assistantId: null,
            domainId: null,
            beginDate: null,
            endDate: null,
            comment: "",
            infoStage: "",
        };

        this.withoutPatientKeys = Object.keys(this.blankInfo);
        this.withPatientKeys = [...this.withoutPatientKeys, "clientId", "reasonId", "consultantId", "knowAboutClinicId", "preparationTimeBegin", "preparationTimeEnd"];
        this.newClientFields = ["lname", "fname", "sname", "phoneNumber", "birthday", "sex"];

        this.state = {
            ...this.state,
            withoutPatient: false,
            needClear: false,
            needConsult: false,
            selectedConsult: false,
            searchClients: "",
            reasons: [],
            recommendationTypes: [],
            showRetVis: true,
            info: { ...this.blankInfo },
        };

        let start = -5;
        this.minutesItems = new Array(12).fill().map(() => {
            start += 5;

            return { id: start, name: `${start} ${this.tr("main.minutes")}` };
        });

        start = -1;
        this.hoursItems = new Array(6).fill().map(() => {
            start += 1;

            let l = "main.hhh";
            if (start === 1)
                l = "main.h";
            else if (start === 0 || start === 5)
                l = "main.hh";

            return { id: start, name: `${start} ${this.tr(l)}` };
        });
    }

    get popupName() {
        return "addAppPopup";
    }

    show(info, client, hideCb) {
        this.state.info = { ...this.state.info, ...info };
        this.state.showRetVis = true;
        this.state.client = client?.id ? client : null;
        this.state.info.knowAboutClinicId = this.state.client?.knowAboutClinicId || 0;
        this.state.currentRetVis = false;

        this.isBuffer = this.state.info.status === "WI_BUFFER_CREATED";

        this.dialogTitle = this.isBuffer ? "buffer.write" : (this.state.info.id ? "app.changeApp" : "main.appoint_new");
        if (info.mode === "show")
            this.dialogTitle = "main.infoVisit";

        this.hidCb = hideCb;

        super.show();
    }

    setInfoState(key, value) {
        this.state.info[key] = value;
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;

        this.setState({ info });
    }

    changeClearTimeState(key, value) {
        const time = value * this._helper.date.msInMinute;
        this.changeInfoState(key, time);
    }

    async onShow() {
        const { info, client } = this.state;
        const { id, consultantId, preparationTimeBegin, preparationTimeEnd, stageId, forClientId,
            createdTime, beginDate } = info;
        let { comment } = info;

        const needConsult = !!consultantId;
        const needClear = !!preparationTimeBegin || !!preparationTimeEnd;
        const withoutPatient = id ? !client : false;
        let messages = [];
        if (client?.id) {
            this.getInfoRetVisits(client.id);
            const respMess = await this._request.messages.getMessagesByClientId(client.id, new Date(createdTime), new Date(createdTime));
            messages = (respMess?.data || []).filter(it => {
                const match = it.text.match(/(\d{2}:\d{2}) (\d{2}\.\d{2}\.\d{4})/);
                if (match) {
                    const [day, month, year] = match[2].split('.').map(Number);
                    const [hours, minutes] = match[1].split(':').map(Number);
                    const appointmentDate = new Date(year, month - 1, day, hours, minutes);
                    if (this._helper.date.equealDataTimes(this._helper.date.toUtc(new Date(beginDate)), appointmentDate))
                        return true;
                }
                return false;
            });
        }

        if (stageId && !comment && +forClientId === client?.id) {
            this._helper.showLoading();
            const resp = await this._request.treatmentTasks.getById(stageId);
            const infoStage = (resp?.data || []);
            if (infoStage[0]) {
                let direction = "";
                const { treatmentDirection } = this._config;
                const el = treatmentDirection.find(it => it.id === infoStage[0].treatmentDirectionId);
                if (el)
                    direction = this.tr(el.name);
                comment = `${this._helper.string.capitalize(this.tr("client.teeth"))}: ${this._helper.getTeethNames(infoStage[0].teeth).join(", ")} ${direction} `;
            }
            this._helper.hideLoading();
            this.state.info.comment = comment;
        }

        this.commentArea.value = comment || "";

        let { reasons, recommendationTypes } = globalThis.appPageView.state;
        const searchClients = "";
        reasons = reasons.filter(it => it.id !== 16);

        if (this.selectReference)
            this.selectReference.value = info.knowAboutClinicDetails;

        this.setState({ reasons, recommendationTypes, needConsult, needClear, searchClients, withoutPatient, messages });
    }

    onHide() {
        this.setState({
            needClear: false,
            needConsult: false,
            withoutPatient: false,
            info: { ...this.blankInfo }
        });
    }

    save() {
        const { withoutPatient, info, client, needConsult, needClear, currentRetVis } = this.state;

        const data = { ...info };
        data.beginDate = this._helper.date.toStr(data.beginDate);
        data.endDate = this._helper.date.toStr(data.endDate);

        const fileds = withoutPatient ? this.withoutPatientKeys : this.withPatientKeys;
        const dataOnly = {};

        fileds.forEach(key => {
            dataOnly[key] = data[key];
        });

        if (!withoutPatient) {
            let validClient = false;

            if (client?.id) {
                dataOnly.clientId = client?.id;
                validClient = true;
            } else {
                validClient = true;
                this.newClientFields.forEach(key => {
                    let value = data[key];
                    if (key === "sex") {
                        value = value === undefined ? this.getSexByName(data.lname, data.fname) : value;

                        if ((value !== 0 && value !== 1))
                            validClient = false;

                    } else if (key === "phoneNumber" && value?.length !== 12)
                        validClient = false;
                    else if (key !== "birthday" && key !== "sname" && (!value || value.length < 2))
                        validClient = false;

                    dataOnly[key] = value;
                });

                if (this.clientsSelector.values && this.clientsSelector.values.length > 0) {
                    this.showError("main.clientExist");
                    return;
                }
            }

            if (!validClient || (needConsult && !dataOnly.consultantId)) {
                this.lnameInput && this.lnameInput.validate();
                this.fnameInput && this.fnameInput.validate();
                this.telephoneInput && this.telephoneInput.validate();

                let message = "";
                if (!dataOnly["fname"])
                    message = "main.fillFName";
                else if (!dataOnly["lname"])
                    message = "main.fillLName";
                else if (!dataOnly["phoneNumber"])
                    message = "main.fillPhone";
                else if ((dataOnly["sex"] !== 0 && dataOnly["sex"] !== 1))
                    message = "main.fillSex";

                return this.showError(message);
            }


            if (!needClear) {
                dataOnly.preparationTimeBegin = 0;
                dataOnly.preparationTimeEnd = 0;
            }

            if (dataOnly.consultantId && !needConsult)
                dataOnly.consultantId = null;
        }

        if (this.isBuffer) {
            dataOnly.addedToBuffer = this._helper.date.toStr();
            dataOnly.changedBy = this._helper.getProfileId();
        }

        if (this.selectReference)
            dataOnly.knowAboutClinicDetails = this.selectReference.value;

        if (info.stageId)
            dataOnly.treatmentTaskId = info.stageId;

        if (data?.visitRules?.length && currentRetVis) {
            //this._request.repeatedVisits.delete(currentRetVis);
            console.log("currentRetVis", currentRetVis, data.visitRules);

            const comment1 = data.visitRules.find(it => it.id === currentRetVis).title;
            dataOnly.comment1 = comment1;
        }

        dataOnly.patientVehicle = { parkingPriority: "REQUIRED" };

        this.saveSend(dataOnly, data.id);
    }

    async saveSend(info, id) {
        this._helper.showLoading();

        let resp;
        if (!id)
            resp = await this._request.visits.add(info);
        else
            resp = await this._request.visits.update(id, info);

        this._helper.hideLoading();

        if (resp?.data) {
            this.hide();

            if (this.hidCb?.apply)
                this.hidCb();
        }
    }

    onWordChange(key, value) {
        this.setInfoState(key, value);

        const { lname, fname, phoneNumber } = this.state.info;
        const arr = [];

        if (lname?.length)
            arr.push(lname);
        if (fname?.length)
            arr.push(fname);
        if (phoneNumber?.length)
            arr.push(phoneNumber);

        const searchClients = arr.join(" ");

        this.setState({ searchClients }, () => {
            if (this.clientsSelector)
                this.clientsSelector.value = searchClients;
        });
    }

    async getInfoRetVisits(id) {
        if (id) {
            const { data } = await this._request.repeatedVisits.getRepeatedVisits(id);
            if (data)
                this.changeInfoState("visitRules", data);
        }
    }

    onSelectClient(client) {
        this.newClientFields.forEach(key => {
            delete this.state.info[key];
        });

        if (client)
            this.getInfoRetVisits(client.id);

        this.setState({ searchClients: "", client });
    }

    closeClients() {
        this.setState({ searchClients: "" });
    }

    changeDuration(flag, value) {
        const { endDate } = this.state.info;

        if (flag === "h")
            endDate.setHours(value);
        else
            endDate.setMinutes(value);

        this.changeInfoState("endDate", endDate);
    }

    getSexByName(lname, fname) {
        const value = lname || fname;
        if (!value)
            return null;

        const at1 = (lname || "").at(-1);
        const at2 = (fname || "").at(-1);

        //const last = value.at(-1);

        return (at1 === "а" || at1 === "я" || at2 === "а" || at2 === "я") ? 1 : 0;
    }

    insertClient(it, isNewApp) {
        return (
            <ItemClient
                info={it}
                removeCb={isNewApp ? this.changeState.bind(this, "client", null) : null}
            />
        );
    }

    onClickRetVis({ title, id }) {
        this.commentArea.value = title || "";
        this.changeInfoState("comment", title);
        this.changeState("currentRetVis", id);
    }

    renderFoundPatients() {
        return (
            <div className="flex gap8 col">
                <div className="titleFoundPatients text p1 flex between">
                    <div>{this.tr("main.records")}</div>
                    <CloseIcon className="close hand" onClick={this.closeClients.bind(this)} />
                </div>
                <SelectClient ref={el => this.clientsSelector = el} onClick={this.onSelectClient.bind(this)}
                />
            </div>
        );
    }

    renderReturnVisit(it, i) {
        const { currentRetVis } = this.state;
        const { title, targetDate, doctorId } = it;
        const doctor = this.props.getDoctorById(doctorId);
        const doctorName = this._helper.string.formatFullName(doctor, "short");
        return (<ItemHuman
            key={i + "returnVisit"}
            active={(currentRetVis === it.id)}
            onClick={this.onClickRetVis.bind(this, it)}
            firstRow={title}
            secondRow={`${this._helper.date.toStr(targetDate, "DD MMMM YYYY")}, ${doctorName}`}
        />);
    }

    renderWithStartFileds(isNewApp) {
        const { reasons, /*recommendationTypes,*/ info, client, searchClients, showRetVis } = this.state;
        const { reasonId, sex, lname, fname, visitRules } = info;
        const hasClient = !!client?.id;
        const sexValue = sex === undefined ? this.getSexByName(lname, fname) : sex;

        return (
            <>
                {hasClient && this.insertClient(client, isNewApp)}
                {!hasClient && (
                    <div className="inputs flex gap16">
                        {this.insertInput({
                            ref: el => this.lnameInput = el,
                            itemStyle: "flex1",
                            label: "main.lname",
                            placeHolder: "main.lnamePlace",
                            required: true,
                            validator: this._helper.inputValidators.capitalize,
                            onChange: this.onWordChange.bind(this, "lname")
                        })}
                        {this.insertInput({
                            ref: el => this.fnameInput = el,
                            itemStyle: "flex1",
                            label: "main.fname",
                            placeHolder: "main.fnamePlace",
                            required: true,
                            validator: this._helper.inputValidators.capitalize,
                            onChange: this.onWordChange.bind(this, "fname")
                        })}
                    </div>
                )}
                {!hasClient && (
                    <div className="inputs flex gap16">
                        {this.insertInput({
                            itemStyle: "flex1",
                            label: "main.sname",
                            placeHolder: "main.snamePlace",
                            validator: this._helper.inputValidators.capitalize,
                            onChange: this.changeInfoState.bind(this, "sname")
                        })}
                        <InputPhone
                            ref={el => this.telephoneInput = el}
                            itemStyle="flex1"
                            label="main.telephone"
                            required={true}
                            onChange={this.onWordChange.bind(this, "phoneNumber")}
                        />
                    </div>
                )}
                {!hasClient && <SelectDate onChange={this.changeInfoState.bind(this, "birthday")} />}
                {!hasClient && (
                    <div className="flex col gap8">
                        {this.insertSexSelect({
                            value: sexValue,
                            label: "client.sex",
                            onChange: this.changeInfoState.bind(this, "sex"),
                        })}
                    </div>
                )}
                {searchClients.length > 2 && this.renderFoundPatients()}
                {showRetVis && hasClient && visitRules?.length ? (
                    <div className="flex col gap8">
                        <div className="flex flex1 between">
                            <div className="text p2 black3">{this.tr("main.remindRetVisit")}</div>
                            <CloseIcon className="close hand" onClick={this.changeState.bind(this, "showRetVis", false)} />
                        </div>
                        <div className="wrapReturnVisit flex col gap4 rad8 scrolling">
                            {visitRules.map((it, i) => this.renderReturnVisit(it, i))}
                        </div>
                    </div>
                ) : false}
                <div className="flex col gap8">
                    {this.insertSelect({
                        value: reasonId,
                        label: "main.reason",
                        labelKey: "title",
                        showLeftIcon: false,
                        placeHolder: "main.notIndicated",
                        items: reasons,
                        onChange: this.setInfoState.bind(this, "reasonId"),
                    })}
                </div>
                {!hasClient && (
                    <div className="flex col gap8">
                        {/*this.insertSelect({
                            value: knowAboutClinicId,
                            labelKey: "title",
                            label: "main.learned",
                            showLeftIcon: false,
                            placeHolder: "main.notIndicated",
                            items: recommendationTypes,
                            onChange: this.setInfoState.bind(this, "knowAboutClinicId")
                        })*/}
                        {this.insertSelectReference({
                            ref: el => this.selectReference = el
                        })}
                    </div>
                )}
            </>
        );
    }

    getClearLabel(label, value) {
        return (
            <div className="rangeText flex centerV gap8">
                <div className="text p2">{this.tr(label)}</div>
                <div className="text p1">{`${value} ${this.tr("main.minutes")}`}</div>
            </div>
        );
    }

    setValuePrepare(el, value) {
        if (el)
            el.value = value;
    }

    insertClearRange(label, value, key) {
        return (
            <div className="flex1 flex col gap8">
                {this.getClearLabel(label, value)}
                {this.insertInputRange({
                    ref: el => this.setValuePrepare(el, value),
                    items: ["0", "5", "10"],
                    round: true,
                    inputShow: false,
                    onChange: this.changeClearTimeState.bind(this, key)
                })}
            </div>
        );
    }

    insertClear(fromMs, toMs) {
        const { msInMinute } = this._helper.date;
        const from = fromMs / msInMinute;
        const to = toMs / msInMinute;

        return (
            <div className="flex gap24">
                {this.insertClearRange("main.beforeAppointment", from, "preparationTimeBegin")}
                {this.insertClearRange("main.beforeAppointment", to, "preparationTimeEnd")}
            </div>
        );
    }

    getDoctor(id) {
        if (!id)
            return "Не указано";
        if (id === 1014)
            return "Личный кабинет";

        const doctor = this.props.getDoctorById(id);
        const resp = this._helper.string.formatFullName(doctor, "short");
        return resp;
    }

    renderBufferFileds() {
        const { endDate, doctorId } = this.state.info;
        const h = endDate.getHours();
        const m = endDate.getMinutes();

        return (
            <>
                {this.insertSelectDoctor({
                    value: doctorId,
                    label: "client.doctor",
                    onClick: this.changeInfoState.bind(this, "doctorId")
                })}
                {this.insertRowText("main.duration")}
                <div className="flex gap16">
                    <div className="flex1">
                        {this.insertSelect({
                            value: h,
                            showLeftIcon: false,
                            placeHolder: "main.hoursS",
                            items: this.hoursItems,
                            onChange: this.changeDuration.bind(this, "h")
                        })}
                    </div>
                    <div className="flex1">
                        {this.insertSelect({
                            value: m,
                            showLeftIcon: false,
                            placeHolder: "main.minutesS",
                            items: this.minutesItems,
                            onChange: this.changeDuration.bind(this, "m")
                        })}
                    </div>
                </div>
            </>
        );
    }

    renderWithEndFileds() {
        const { needConsult, info } = this.state;
        const { consultantId } = info;

        return (
            <>
                {this.insertToggleSwitch({
                    checked: needConsult,
                    label: "main.consultation",
                    placeHolder: "main.freeComment",
                    onChange: this.changeState.bind(this, "needConsult")
                })}
                {needConsult && this.insertSelectDoctor({
                    value: consultantId,
                    onClick: this.changeInfoState.bind(this, "consultantId")
                })}
            </>
        );
    }

    renderButtons() {
        const { mode } = this.state.info;

        if (mode !== "show")
            return super.renderButtons();

        return (
            <div className="buttons flex end">
                <div className="flex ">
                    <Button
                        label="main.close"
                        size="small"
                        onClick={this.hide.bind(this)}
                    />
                </div>
            </div>
        );
    }

    renderContent() {
        const { withoutPatient, info, messages/*, needClear*/ } = this.state;
        const { doctorId, beginDate, endDate, id, changedBy, changedTime, createdBy,
            createdTime/*, preparationTimeBegin, preparationTimeEnd */ } = info;
        //const doctor = this.props.getDoctorById(doctorId);
        const isNewApp = !id;

        const created = `${this.getDoctor(createdBy)} ${this._helper.date.toStr(this._helper.date.toLocal(createdTime), "D MMMM YYYY HH:mm")}`;

        let revision = "";
        if (changedBy)
            revision = `${this.getDoctor(changedBy)} ${this._helper.date.toStr(this._helper.date.toLocal(changedTime), "D MMMM YYYY HH:mm")}`;

        return (
            <div>
                {!this.isBuffer && (
                    <div className="mainInfo text p1 flex gap16">
                        <div>{this.tr("client", "doctor")}</div>
                        <div>{this.getDoctor(doctorId)}</div>
                    </div>
                )}
                {!this.isBuffer && (
                    <div className="mainInfo text p1 flex gap16">
                        <div>{this.tr("main", "date_time")}</div>
                        <div>{this._helper.date.toStr(beginDate, "D MMMM YYYY, HH:mm")} - {this._helper.date.toTimeStr(endDate)}</div>
                    </div>
                )}
                {isNewApp && (
                    <div className="infoRight text p1 flex end">
                        <div className="flex centerV gap8 hand" onClick={this.toggleState.bind(this, "withoutPatient")}>
                            {withoutPatient ? <PatientAddIcon /> : <PatientRemoveIcon />}
                            <div>{!withoutPatient ? this.tr("main.withoutPatient") : this.tr("main.withPatient")}</div>
                        </div>
                    </div>
                )}
                <div className="inputsCont flex col gap16">
                    {!withoutPatient && this.renderWithStartFileds(isNewApp)}
                    {this.isBuffer && this.renderBufferFileds()}
                    {this.insertTextarea({
                        ref: el => this.commentArea = el,
                        label: "main.comment",
                        placeHolder: "main.freeComment",
                        onChange: this.setInfoState.bind(this, "comment")
                    })}
                    {/*!withoutPatient && <div className="flex col gap16">
                        {this.insertToggleSwitch({
                            checked: needClear,
                            label: "main.cabinetRequired",
                            onChange: this.changeState.bind(this, "needClear")
                        })}
                        {needClear && this.insertClear(preparationTimeBegin || 0, preparationTimeEnd || 0)}
                    </div>*/}
                    {/*!withoutPatient && this.renderWithEndFileds()*/}
                    {!isNewApp && <div className="content flex col gap4">
                        {this.renderRow("app.appCreated", created)}
                        {this.renderRow("app.appChanged", revision)}
                    </div>}
                    {messages?.length ? <div className="flex col gap8">
                        <div className="black3 text p2">Отправленные сообщения</div>
                        <div className="black3 flex gap8">
                            <div className="text p1" style={{ width: "120px" }}>тип</div>
                            <div className="flex1 text p1">дата</div>
                            <div className="text p1" style={{ width: "100px" }}>Статус</div>
                        </div>
                        {messages.map((it, i) => (<div key={"message" + i} className="flex gap8 centerV">
                            <div className="text p1" style={{ width: "120px" }}>{it.text?.includes("отзыв") ? "смс о завершении" : "смс о визите"}</div>
                            <div className="flex1 flex col gap4 text p1" >
                                <div>{this._helper.date.toStr(this._helper.date.toLocal(it.createdTime), "DD.MM.YYYY HH:mm")}</div>
                                <div className="text p2 black3">{`Отправил: ${this.getDoctor(it?.createdBy)}`}</div>
                            </div>

                            <div className="text p1" style={{ width: "100px" }}>{it.status === "SUCCESS" ? "Доставлено" : "Ошибка"}</div>
                        </div>))}
                    </div> : false}
                </div>

            </div>
        );
    }
}
